import React from 'react';
import PropTypes from 'prop-types';

function FaqSection(props) {
  if (!props.items || !props.items.length) {
    return null;
  }

  return (
    <section className="faq-section">
      {(props.title || props.subtitle) &&
        <div className="landing-section-head text-center">
          {props.title && <h2 className="display-4 my-3">{props.title}</h2>}
          {props.subtitle && <h3 className="lead text-muted my-2">{props.subtitle}</h3>}
        </div>
      }
      <div className="faq-list">
        {props.items.map((item) => (
          <details className="faq-item" key={item.question}>
            <summary>{item.question}</summary>
            <p>{item.answer}</p>
          </details>
        ))}
      </div>
    </section>
  );
}

FaqSection.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    question: PropTypes.string.isRequired,
    answer: PropTypes.string.isRequired
  }))
};

FaqSection.defaultProps = {
  title: null,
  subtitle: null,
  items: []
};

export default FaqSection;
